<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    persistent
  >
    <v-card>
      <v-card-title>
        <span>{{ formTitle }}</span>
        <v-spacer />
        <v-icon @click="closeDialog">
          mdi-close
        </v-icon>
      </v-card-title>

      <ErrorAlert />

      <v-card-text class="pt-5 pb-0">
        <v-form
          ref="form"
          v-model="formValidity"
        >
          <v-text-field
            v-model="form.name"
            :rules="nameRules"
            :disabled="loading"
            :counter="20"
            outlined
            dense
            label="Name"
            @keypress.enter="saveItem"
          />
          <v-textarea
            v-model="form.description"
            :rules="descriptionRules"
            :disabled="loading"
            :counter="100"
            outlined
            dense
            label="Description"
            auto-grow
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-3">
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          class="primary"
          :loading="loading"
          @click="saveItem"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FormMixin from '../../mixins/FormMixin';

export default {
  name: 'OrganizationForm',
  mixins: [FormMixin],

  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      form: {
        name: '',
        description: '',
      },
      defaultForm: {
        name: '',
        description: '',
      },
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 20 || 'Name must be less than 20 characters',
      ],
      descriptionRules: [
        (v) => v == null || (v != null && v.length <= 100) || 'Description must be less than 100 characters',
      ],
    };
  },

  methods: {
    addData() {
      return this.$api.addOrganization(this.formData);
    },

    updateData() {
      return this.$api.updateOrganization({
        id: this.form.id,
        ...this.formData,
      });
    },
  },
};
</script>
